import { useMemo } from "react";
import useSWR from "swr";
import { useSortTimeSheets } from "../../TimeSheetTable/hooks/useSortTimeSheets";

export const useMultiprofileTimesheets = ({ isMyOvertime, params }) => {
    const url = useMemo(() => {
        if (isMyOvertime) {
            return "/time-sheet/multiple-profiles/my-profile-timesheets"
        }
        return "/time-sheet/multiple-profiles/users";
    }, [isMyOvertime]);

    const { data, isLoading } = useSWR({
        url,
        params
    }, { fallbackData: { data: { result: [], totalItems: 0 } } });

    return {
        data: useSortTimeSheets(data?.result || []),
        isLoading,
        totalItems: data?.totalItems || data?.result?.length || 0
    }
}
